const prefix = 'REUSABLE_LINK';

export const GET_REUSABLE_LINK_PAGE_START = `${prefix}/GET_PAGE_START`;
export const GET_REUSABLE_LINK_PAGE_SUCCESS = `${prefix}/GET_PAGE_SUCCESS`;
export const GET_REUSABLE_LINK_PAGE_FAIL = `${prefix}/GET_PAGE_FAIL`;
export const UPDATE_REUSABLE_LINK_PAGE = `${prefix}/UPDATE_REUSABLE_LINK_PAGE`;

export const GENERATE_REUSABLE_INNER_PAGE_START = `${prefix}/GENERATE_INNER_PAGE_START`;
export const GENERATE_REUSABLE_INNER_PAGE_SUCCESS = `${prefix}/GENERATE_INNER_PAGE_SUCCESS`;
export const GENERATE_REUSABLE_INNER_PAGE_FAIL = `${prefix}/GENERATE_INNER_PAGE_FAIL`;
export const RESET_GENERATE_REUSABLE_INNER_PAGE = `${prefix}/RESET_GENERATE_REUSABLE_INNER_PAGE`;

export const SAVE_REUSABLE_FORM = `${prefix}/SAVE_REUSABLE_FORM`;
